"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _icon_wrapper = _interopRequireDefault(require("./icon_wrapper"));
var _templateObject;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
var Wrapper = _styled["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  border-radius: 50%;\n  display: inline-block;\n  overflow: hidden;\n  width: ", ";\n  height: ", ";\n"])), function (props) {
  return props.width;
}, function (props) {
  return props.width;
});
var FlagNzlIcon = /*#__PURE__*/function (_React$Component) {
  function FlagNzlIcon() {
    _classCallCheck(this, FlagNzlIcon);
    return _callSuper(this, FlagNzlIcon, arguments);
  }
  _inherits(FlagNzlIcon, _React$Component);
  return _createClass(FlagNzlIcon, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement(Wrapper, {
        width: this.props.width
      }, /*#__PURE__*/_react["default"].createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        shapeRendering: "geometricPrecision",
        textRendering: "geometricPrecision",
        imageRendering: "optimizeQuality",
        fillRule: "evenodd",
        clipRule: "evenodd",
        viewBox: "0 0 512 512"
      }, /*#__PURE__*/_react["default"].createElement("g", {
        fillRule: "nonzero"
      }, /*#__PURE__*/_react["default"].createElement("path", {
        fill: "#fff",
        d: "M256 0c77.15 0 147.01 31.28 197.57 81.84 50.56 50.56 81.84 120.42 81.84 197.57 0 77.15-31.28 147.01-81.84 197.56-50.56 50.56-120.41 81.84-197.56 81.84-77.15 0-147.01-31.28-197.57-81.84-50.56-50.56-81.84-120.42-81.84-197.57 0-77.15 31.28-147.01 81.84-197.57 50.56-50.56 120.42-81.84 197.57-81.84z",
        id: "background"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        fill: "#09438D",
        d: "M256 .23c141.26 0 255.77 114.51 255.77 255.77 0 141.26-114.51 255.77-255.77 255.77-141.26 0-255.77-114.51-255.77-255.77 0-141.26 114.51-255.77 255.77-255.77z",
        id: "blue_section"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        fill: "#fff",
        d: "M26.93 142.13l38.9-19.46 0 57.03 62.37 0 0-56.94 113.89 56.94 41.74 0 0-20.99-82.52-41.26 82.52 0 0-62.36-82.86 0 82.97-41.5 0-11.82a258.51 258.51 0 0 0-27.94-1.52c-11.27 0-22.36.74-33.25 2.15l-94.55 47.29 0-15.27c-43.45 25.11-78.82 62.64-101.27 107.73z",
        id: "cross_white"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        fill: "#E7394E",
        d: "M41.06 117.33l21.44 0-30.58 15.31a255.81 255.81 0 0 1 9.15-15.31zm214.94-117.1c4.12 0 8.22.11 12.3.3l-109.09 54.55-27.79 0 108.56-54.34a259.46 259.46 0 0 1 16.01-.51zm-206.38 104.69a257.31 257.31 0 0 1 66.07-62.78l0 25.34 168.15 0 0 37.44-168.15 0 0 74.77-37.45 0 0-74.77-28.62 0zm234.33 74.77l-124.74-62.37 27.91 0 96.71 48.42 0 13.96.12 0z",
        id: "cross_red"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        fill: "#fff",
        d: "M425.91 127.99l17.74-12.92-21.93 0-6.81-20.87-6.8 20.87-21.94 0 17.74 12.92-6.77 20.95 17.77-12.94 17.77 12.94-6.77-20.95z",
        id: "star_white_1"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        fill: "#E7394E",
        d: "M422.14 126.84l11.73-8.55-14.5 0-4.46-13.83-4.46 13.83-14.5 0 11.71 8.53-4.56 13.77 11.79-8.5 11.7 8.5-4.46-13.75z",
        id: "star_red_1"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        fill: "#fff",
        d: "M500 193.05l3.33-2.41c-.8-3.03-1.65-6.04-2.56-9.03l-4.5 0-6.11-18.6-6.02 18.6-19.5 0 15.79 11.49-6.01 18.56 15.76-11.47 15.84 11.47-6.02-18.61z",
        id: "star_white_2"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        fill: "#E7394E",
        d: "M496.33 191.89l6.13-4.46-.73-2.6-7.71 0-3.86-11.57-3.76 11.57-11.98 0 9.69 7.06-3.73 11.54 9.84-7.11 9.84 7.11-3.73-11.55z",
        id: "star_red_2"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        fill: "#fff",
        d: "M338.03 216.37l17.74-12.82-21.9 0-6.85-20.99-6.75 20.99-21.99 0 17.81 12.88-6.84 20.87 17.77-12.94 17.77 12.94-6.76-20.92z",
        id: "star_white_3"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        fill: "#E7394E",
        d: "M334.29 215.27l11.82-8.61-14.62 0-4.46-13.84-4.46 13.84-14.5 0 11.74 8.56-4.47 13.86 11.74-8.56 11.75 8.56-4.54-13.81z",
        id: "star_red_3"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        fill: "#fff",
        d: "M427.13 356.53l19.74-14.28-24.39 0-7.57-23.26-7.57 23.26-24.39 0 19.74 14.28-7.58 23.28 19.8-14.41 19.79 14.41-7.58-23.28z",
        id: "star_white_4"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        fill: "#E7394E",
        d: "M423.36 355.38l13.74-9.92-16.96 0-5.22-16.22-5.31 16.22-16.87 0 13.65 9.92-5.18 16.08 13.67-9.93 13.76 9.93-5.27-16.08z",
        id: "star_red_4"
      }))));
    }
  }]);
}(_react["default"].Component);
FlagNzlIcon.defaultProps = {
  width: '20px'
};
var _default = exports["default"] = (0, _icon_wrapper["default"])(FlagNzlIcon);